import Http from "../util/httpUtils"
import Cacher from "./cacher"
import { mall, professionData } from "../constants/conf"
var cacher = Cacher(100)
var hot_val = {
  "0": [0.5, 0.4, 0.5],
  "1": [0.4, 0.1, 0.3],
  "2": [0.2, 0.2, 0.2],
  "3": [0, 0, 0],
  "4": [0, 0.1, 0],
  "5": [0.2, 0.5, 0.2],
  "6": [0.3, 0.7, 0.2],
  "7": [0.4, 1.3, 1],
  "8": [0.7, 1.7, 1],
  "9": [0.8, 1.3, 1],
  "10": [0.8, 1, 0.8],
  "11": [1, 0.9, 1.1],
  "12": [1.5, 1, 2],
  "13": [1.5, 1, 2],
  "14": [0.7, 0.8, 0.7],
  "15": [1.1, 1.2, 1],
  "16": [1, 1, 0.7],
  "17": [1.6, 1.6, 2],
  "18": [2, 2, 2],
  "19": [1, 2, 1],
  "20": [1.4, 2, 1],
  "21": [1, 1.5, 1],
  "22": [1, 0.8, 1],
  "23": [0.7, 0.6, 0.8],
}
function genHeat(data, hour) {
  let points = []
  data.forEach((track, i) => {
    track.forEach(point => {
      point[2] = hot_val[hour][i]
      points.push(point)
    })
  })
  return points
}
export default {
  /**
   * 商场列表
   */
  getMalls() {
    return new Promise((resolve, reject) => {
      let data = mall.map(m => {
        let { id, name, center, bounds } = m
        return { id, name, center, bounds }
      })
      resolve(data)
    })
  },
  /**
   * 车流量
   */
  getCarFlowData(hours) {
    return new Promise((resolve, reject) => {
      let res = []
      mall.forEach((m, mIdx) => {
        let s = { name: m.name, values: [] }
        hours.forEach((h, i) => {
          s.values[i] = m.car[h]
        })
        res.push(s)
      })
      resolve(res)
    })
  },
  /**
   * 客流量
   */
  getCustomerFlowData(hours) {
    return new Promise((resolve, reject) => {
      let res = []
      mall.forEach((m, mIdx) => {
        let s = { name: m.name, values: [] }
        hours.forEach((h, i) => {
          s.values[i] = m.customer[h]
        })
        res.push(s)
      })
      resolve(res)
    })
  },
  /**
   * 用户信息
   */
  getProfessionData(hours) {
    return new Promise((resolve, reject) => {
      resolve(professionData)
    })
  },
  /**
   * 车辆轨迹
   */
  getTrajectory() {
    return new Promise((resolve, reject) => {
      Http.get("/data/lgraph.json").then(data => {
        let res = data.map(function(busLine, idx) {
          var prevPt = [0, 0]
          var points = []

          for (var i = 0; i < busLine.length; i += 2) {
            var pt = [busLine[i], busLine[i + 1]]
            if (i > 0) {
              pt = [prevPt[0] + pt[0], prevPt[1] + pt[1]]
            }
            prevPt = pt
            points.push([pt[0] / 1e6, pt[1] / 1e6])
          }
          return {
            coords: points,
          }
        })
        resolve(res)
      })
    })
  },
  /**
   * 热力数据
   * @param {*} hour
   */
  getHeat(hour) {
    return new Promise((resolve, reject) => {
      let c = cacher.get("heat")
      if (c) {
        resolve(genHeat(c, hour))
        return
      }
      Http.get("/data/heat.json").then(data => {
        cacher.set("heat", data)
        resolve(genHeat(data, hour))
      })
    })
  },
}
